import request from "superagent";
import { url_endpoint } from "../config";
import authHeader from "../Routes/Utils/AuthHeader";
import { firebaseAnalytics } from "../Routes/Utils/firebaseConfig";

export default class FirebaseService {
  //this.state.player_data.ClienteId, this.props.match.params.id , acao
  static saveOnPlay = async (ClienteId, postcastId, acao, callback) => {
    //dashboard.blogplay.com.br
    try {
      /*
      if (
        document.location.href ==
          "https://dashboard.blogplay.com.br/painel/configuracoes" ||
        document.location.href ==
          "https://dashboard.blogplay.com.br/painel/configuracoes"
      ) {
        return;
      }
      */

      const rest = await request
        .post(url_endpoint + "playerview/save")
        .set(authHeader())
        .field("cliId", ClienteId)
        .field("postId", postcastId)
        .field("acao", acao);
    } catch (error) {
      console.log("2 saveOnPlay error ", error);
      callback(false, error);
    }
  };

  static getDadosPlayer = async (postID, acao, callback) => {
    const rest = await request
      .get(url_endpoint + "playerview/postcast/" + postID + "/" + acao + "")
      .set(authHeader());
    let somaTotal = 0;
    rest.body.forEach(function (childSnapshot) {
      somaTotal += parseInt(childSnapshot["count"]);
    });
    callback(somaTotal);
  };
}
